import React from "react";
import Container from "./Container";
import Section from "./Section";
import Grid from "./Grid";
import { QuoteForm } from "./QuoteForm";
import styled, { css } from "styled-components";

const TestimonialStyles = styled.li`
  ${({ ...props }) => css`
    padding-left: 24px;
    border-left: solid 2px ${props.theme.colors.primary};

    & + & {
      margin-top: 24px;
    }

    cite {
      strong {
        display: block;
      }
    }
    @media (min-width: ${props.theme.breakpoints.md}) {
      padding-left: 32px;
      & + & {
        margin-top: 32px;
      }
    }
  `}
`;

export const Testimonials = ({ testimonials, source }) => {
  return (
    testimonials &&
    testimonials.length > 0 && (
      <Section>
        <Container>
          <Grid equalHeight>
            <Grid item md="8">
              <ul>
                {testimonials.map((testimonial, index) => {
                  return (
                    <TestimonialStyles key={index}>
                      <blockquote>
                        <p>"{testimonial.testimonialQuote}"</p>
                        <footer>
                          <cite>
                            {testimonial.testimonialName && (
                              <strong>{testimonial.testimonialName}</strong>
                            )}
                            {testimonial.testimonialCompany && (
                              <span>{testimonial.testimonialCompany}</span>
                            )}
                          </cite>
                        </footer>
                      </blockquote>
                    </TestimonialStyles>
                  );
                })}
              </ul>
            </Grid>
            <Grid item md="4">
              <QuoteForm source={source} />
            </Grid>
          </Grid>
        </Container>
      </Section>
    )
  );
};
